/**
 * Shared helper for the `dateConstraint` field option ('past' | 'future' | null/undefined).
 * Used by DatePicker, DateTimePicker, and any other date input that wants the
 * same "today and earlier only" / "today and later only" enforcement.
 */

const pad = (n) => String(n).padStart(2, '0');

/** Local calendar date as YYYY-MM-DD — deliberately not toISOString(), which
 * is UTC-based and can report the wrong day depending on timezone offset. */
export function localTodayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function localNowHHMM() {
  const d = new Date();
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** { min, max } date bounds (YYYY-MM-DD) for a constraint, or {} for none. */
export function getDateBounds(dateConstraint) {
  if (dateConstraint === 'past') return { max: localTodayISO() };
  if (dateConstraint === 'future') return { min: localTodayISO() };
  return {};
}

export function isDayAllowed(dateConstraint, isoDate) {
  const { min, max } = getDateBounds(dateConstraint);
  if (min && isoDate < min) return false;
  if (max && isoDate > max) return false;
  return true;
}

/** Time-of-day bounds only matter when the selected day is today — clamps
 * the native <input type="time">'s min/max so a same-day pick still respects
 * the constraint down to the minute. */
export function getTimeBounds(dateConstraint, isoDate) {
  if (!dateConstraint || isoDate !== localTodayISO()) return {};
  const now = localNowHHMM();
  if (dateConstraint === 'past') return { max: now };
  if (dateConstraint === 'future') return { min: now };
  return {};
}
